import React, { PropsWithChildren, ReactNode } from 'react';
import { DeleteButton } from '../../../components/form/MultiInput/Buttons';
import './InputGroup.css';

interface Props {
  className?: string;
  delete?: {
    action: (e: React.MouseEvent<any>) => void | Promise<void>;
    disabled: boolean;
  };
}

export const InputGroup = (props: PropsWithChildren<Props>): ReactNode => {
  const classes = ['p-inputgroup flex w-full min-w-0 edit-input-group', props.className];

  return (
    <div className={classes.join(' ')}>
      {props.children}
      {props.delete &&
        <DeleteButton
          onClick={props.delete.action}
          disabled={!props.delete.action || props.delete.disabled}
        />
      }
    </div>
  );
};
